import {
  EDIT_SOFTSKILL_ABILITY_USER_POSITION,
  EDIT_SOFTSKILL_ABILITY_USER_POSITION_SUCCESS,
  EDIT_SOFTSKILL_ABILITY_USER_POSITION_CLEAN,
  EDIT_SOFTSKILL_ABILITY_USER_POSITION_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  ability: undefined,
}

const SoftskillAbilityUserPositionEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_SOFTSKILL_ABILITY_USER_POSITION:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_SOFTSKILL_ABILITY_USER_POSITION_SUCCESS:
      state = {
        ...state,
        ability: action.payload.ability,
        loading: false,
        done: true,
      }
      break
    case EDIT_SOFTSKILL_ABILITY_USER_POSITION_CLEAN:
      state = initialState
      break
    case EDIT_SOFTSKILL_ABILITY_USER_POSITION_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillAbilityUserPositionEdit
